(function dotTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  global.dotq = global.dotq || [];
  const configurations = {};

  const previousModule = global.NewHomeSource.Analytics.DotTracker;

  /**
   * @private
   * conversionDotGeminiYahoo: track event to DOT Gemeni yahoo object.
   *
   */
  function conversionDotGeminiYahoo() {
    global.dotq.push({
      projectId: '10000',
      properties: {
        pixelId: '21869',
        qstrings: {
          et: 'custom',
          ec: 'submit',
          ea: 'direct lead',
          el: 'source'
        }
      }
    });
  }

  function DotTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  DotTracker.onDemandTracker = function () {
    if (!this.isFromEuropeanCountry && this.isDirectLead) {
      conversionDotGeminiYahoo();
    }

    return true;
  };

  /**
     * @public
     * onDemandTrackerValidator: validates if this track need to be fired.
     *
     * @param {string} data with the specific event type.
     * @returns true if the eventType is a DotEvent
     */
  DotTracker.onDemandTrackerValidator = function (data) {
    return data && data.eventType === 'DotEvent';
  };

  /**
     * @public
     * noConflict: Returns control of NewHomeSource.Analytics.DotTracker to the previous script.
     */
  DotTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.DotTracker = previousModule;
    return DotTracker;
  };

  global.NewHomeSource.Analytics.DotTracker = DotTracker;

  return DotTracker;
}(window));
